import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaUser } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { PATHS } from "../../routes/paths";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handlePasswordReset = (e) => {
    e.preventDefault();

    alert(
      "Instruções de recuperação de senha enviadas para o email fornecido!",
    );
    navigate(PATHS.LOGIN);
  };

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center vh-100 bg-light">
      <div
        className="card shadow p-4 rounded"
        style={{ maxWidth: "400px", width: "100%" }}
      >
        <div className="d-flex justify-content-center align-items-center mb-3">
          <div className="rounded-circle text-white d-flex justify-content-center align-items-center custom-icon">
            <FaUser />
          </div>
        </div>

        <h2 className="text-custom-blue fw-bold text-center">
          Esqueceu sua senha?
        </h2>
        <p className="text-muted text-center">
          Insira o endereço de email associado à sua conta e enviaremos
          instruções para redefinir sua senha.
        </p>

        <form onSubmit={handlePasswordReset} className="mb-3">
          <div className="input-group mb-3">
            <span className="input-group-text bg-light text-custom-blue">
              <FaEnvelope />
            </span>
            <input
              type="email"
              className="form-control custom-input"
              placeholder="Digite seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn custom-button w-100">
            ENVIAR
          </button>
        </form>

        <div className="text-end">
          <button
            type="button"
            className="btn btn-link text-custom-blue p-0"
            onClick={() => navigate(PATHS.LOGIN)}
          >
            Voltar para o login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
